export enum YesNo {    
    Unknown = -1,
    No = 0,
    Yes = 1
}